import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { encode as base64url } from '../../runtime/base64url.js';
import _encrypt from '../../runtime/encrypt.js';
import { deflate } from '../../runtime/zlib.js';
import generateIv from '../../lib/iv.js';
import encryptKeyManagement from '../../lib/encrypt_key_management.js';
import { JOSENotSupported, JWEInvalid } from '../../util/errors.js';
import isDisjoint from '../../lib/is_disjoint.js';
import { encoder, decoder, concat } from '../../lib/buffer_utils.js';
import validateCrit from '../../lib/validate_crit.js';
export var unprotected = Symbol();
export var FlattenedEncrypt = /*#__PURE__*/function () {
  function FlattenedEncrypt(plaintext) {
    _classCallCheck(this, FlattenedEncrypt);
    if (!(plaintext instanceof Uint8Array)) {
      throw new TypeError('plaintext must be an instance of Uint8Array');
    }
    this._plaintext = plaintext;
  }
  _createClass(FlattenedEncrypt, [{
    key: "setKeyManagementParameters",
    value: function setKeyManagementParameters(parameters) {
      if (this._keyManagementParameters) {
        throw new TypeError('setKeyManagementParameters can only be called once');
      }
      this._keyManagementParameters = parameters;
      return this;
    }
  }, {
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this._protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }
      this._protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setSharedUnprotectedHeader",
    value: function setSharedUnprotectedHeader(sharedUnprotectedHeader) {
      if (this._sharedUnprotectedHeader) {
        throw new TypeError('setSharedUnprotectedHeader can only be called once');
      }
      this._sharedUnprotectedHeader = sharedUnprotectedHeader;
      return this;
    }
  }, {
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this._unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }
      this._unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "setAdditionalAuthenticatedData",
    value: function setAdditionalAuthenticatedData(aad) {
      this._aad = aad;
      return this;
    }
  }, {
    key: "setContentEncryptionKey",
    value: function setContentEncryptionKey(cek) {
      if (this._cek) {
        throw new TypeError('setContentEncryptionKey can only be called once');
      }
      this._cek = cek;
      return this;
    }
  }, {
    key: "setInitializationVector",
    value: function setInitializationVector(iv) {
      if (this._iv) {
        throw new TypeError('setInitializationVector can only be called once');
      }
      this._iv = iv;
      return this;
    }
  }, {
    key: "encrypt",
    value: function () {
      var _encrypt2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, options) {
        var joseHeader, alg, enc, encryptedKey, cek, parameters, _yield$encryptKeyMana, additionalData, protectedHeader, aadMember, ciphertext, tag, deflated, _yield$_encrypt, _yield$_encrypt2, jwe;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader)) {
                  _context.next = 2;
                  break;
                }
                throw new JWEInvalid('either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()');
              case 2:
                if (isDisjoint(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) {
                  _context.next = 4;
                  break;
                }
                throw new JWEInvalid('JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint');
              case 4:
                joseHeader = _objectSpread(_objectSpread(_objectSpread({}, this._protectedHeader), this._unprotectedHeader), this._sharedUnprotectedHeader);
                validateCrit(JWEInvalid, new Map(), options === null || options === void 0 ? void 0 : options.crit, this._protectedHeader, joseHeader);
                if (!(joseHeader.zip !== undefined)) {
                  _context.next = 11;
                  break;
                }
                if (!(!this._protectedHeader || !this._protectedHeader.zip)) {
                  _context.next = 9;
                  break;
                }
                throw new JWEInvalid('JWE "zip" (Compression Algorithm) Header MUST be integrity protected');
              case 9:
                if (!(joseHeader.zip !== 'DEF')) {
                  _context.next = 11;
                  break;
                }
                throw new JOSENotSupported('Unsupported JWE "zip" (Compression Algorithm) Header Parameter value');
              case 11:
                alg = joseHeader.alg, enc = joseHeader.enc;
                if (!(typeof alg !== 'string' || !alg)) {
                  _context.next = 14;
                  break;
                }
                throw new JWEInvalid('JWE "alg" (Algorithm) Header Parameter missing or invalid');
              case 14:
                if (!(typeof enc !== 'string' || !enc)) {
                  _context.next = 16;
                  break;
                }
                throw new JWEInvalid('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
              case 16:
                if (!(alg === 'dir')) {
                  _context.next = 21;
                  break;
                }
                if (!this._cek) {
                  _context.next = 19;
                  break;
                }
                throw new TypeError('setContentEncryptionKey cannot be called when using Direct Encryption');
              case 19:
                _context.next = 24;
                break;
              case 21:
                if (!(alg === 'ECDH-ES')) {
                  _context.next = 24;
                  break;
                }
                if (!this._cek) {
                  _context.next = 24;
                  break;
                }
                throw new TypeError('setContentEncryptionKey cannot be called when using Direct Key Agreement');
              case 24:
                _context.next = 26;
                return encryptKeyManagement(alg, enc, key, this._cek, this._keyManagementParameters);
              case 26:
                _yield$encryptKeyMana = _context.sent;
                cek = _yield$encryptKeyMana.cek;
                encryptedKey = _yield$encryptKeyMana.encryptedKey;
                parameters = _yield$encryptKeyMana.parameters;
                if (parameters) {
                  if (options && unprotected in options) {
                    if (!this._unprotectedHeader) {
                      this.setUnprotectedHeader(parameters);
                    } else {
                      this._unprotectedHeader = _objectSpread(_objectSpread({}, this._unprotectedHeader), parameters);
                    }
                  } else {
                    if (!this._protectedHeader) {
                      this.setProtectedHeader(parameters);
                    } else {
                      this._protectedHeader = _objectSpread(_objectSpread({}, this._protectedHeader), parameters);
                    }
                  }
                }
                this._iv || (this._iv = generateIv(enc));
                if (this._protectedHeader) {
                  protectedHeader = encoder.encode(base64url(JSON.stringify(this._protectedHeader)));
                } else {
                  protectedHeader = encoder.encode('');
                }
                if (this._aad) {
                  aadMember = base64url(this._aad);
                  additionalData = concat(protectedHeader, encoder.encode('.'), encoder.encode(aadMember));
                } else {
                  additionalData = protectedHeader;
                }
                if (!(joseHeader.zip === 'DEF')) {
                  _context.next = 45;
                  break;
                }
                _context.next = 37;
                return ((options === null || options === void 0 ? void 0 : options.deflateRaw) || deflate)(this._plaintext);
              case 37:
                deflated = _context.sent;
                _context.next = 40;
                return _encrypt(enc, deflated, cek, this._iv, additionalData);
              case 40:
                _yield$_encrypt = _context.sent;
                ciphertext = _yield$_encrypt.ciphertext;
                tag = _yield$_encrypt.tag;
                _context.next = 51;
                break;
              case 45:
                ;
                _context.next = 48;
                return _encrypt(enc, this._plaintext, cek, this._iv, additionalData);
              case 48:
                _yield$_encrypt2 = _context.sent;
                ciphertext = _yield$_encrypt2.ciphertext;
                tag = _yield$_encrypt2.tag;
              case 51:
                jwe = {
                  ciphertext: base64url(ciphertext),
                  iv: base64url(this._iv),
                  tag: base64url(tag)
                };
                if (encryptedKey) {
                  jwe.encrypted_key = base64url(encryptedKey);
                }
                if (aadMember) {
                  jwe.aad = aadMember;
                }
                if (this._protectedHeader) {
                  jwe.protected = decoder.decode(protectedHeader);
                }
                if (this._sharedUnprotectedHeader) {
                  jwe.unprotected = this._sharedUnprotectedHeader;
                }
                if (this._unprotectedHeader) {
                  jwe.header = this._unprotectedHeader;
                }
                return _context.abrupt("return", jwe);
              case 58:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function encrypt(_x, _x2) {
        return _encrypt2.apply(this, arguments);
      }
      return encrypt;
    }()
  }]);
  return FlattenedEncrypt;
}();